import { Component } from '@angular/core';
import { GlobalButtonComponent } from '../../../shared/components/global-button/global-button.component';
import { PictureComponent } from '../../../shared/components/picture/picture.component';
import { JumpToComponent } from '../../../shared/components/jump-to/jump-to.component';

@Component({
  selector: '[callouts]',
  imports: [GlobalButtonComponent, PictureComponent],
  templateUrl: './callouts.component.html',
  styleUrl: './callouts.component.scss',
})
export class CalloutsComponent {
  cardButton = {
    buttonLabel: 'Learn more',
    buttonUrl: '/hcp/early-detection-of-t1d/',
    openInNewTab: false,
    buttonIcon: 'right-icon',
  };

  cardButton2 = {
    buttonLabel: 'Explore screening resources',
    buttonUrl: '/hcp/t1d-screening-resources/',
    openInNewTab: true,
    buttonIcon: 'right-icon',
  };
}
